import Rules from './Rules'
import PrivilegedRules from './PrivilegedRules'

export { Rules, PrivilegedRules }



// WEBPACK FOOTER //
// ./src/views/rules/index.js